import { useState, useEffect } from 'react';

interface WalletConfig {
  walletConnectProjectId?: string;
  configured: boolean;
  error?: string;
  loading: boolean;
}

export const useWalletConfig = () => {
  const [config, setConfig] = useState<WalletConfig>({
    configured: false,
    loading: true,
  });

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        // Try to get from environment first (for local development)
        const envProjectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID;
        if (envProjectId && envProjectId !== 'your_project_id_here') {
          setConfig({
            walletConnectProjectId: envProjectId,
            configured: true,
            loading: false,
          });
          return;
        }

        // Fall back to Edge Function for production
        const response = await fetch(
          `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/wallet-config`,
          {
            headers: {
              'apikey': import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
            },
          }
        );

        if (!response.ok) {
          throw new Error('Failed to fetch wallet config');
        }

        const data = await response.json();
        setConfig({
          walletConnectProjectId: data.walletConnectProjectId,
          configured: data.configured,
          loading: false,
        });
      } catch (error) {
        console.error('Error fetching wallet config:', error);
        setConfig({
          configured: false,
          loading: false,
          error: error instanceof Error ? error.message : 'Unknown error',
        });
      }
    };

    fetchConfig();
  }, []);

  return config;
};
